import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaHorariosPagoPorEventoRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultaHorariosPagoPorEventoRest",
    rutaEndPoint:
      "/SbConsultaHorariosPagoPorEventoSelEBS/ConsultaHorariosPagoPorEventoRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA
export interface ConsultaHorariosPagoPorEventoRest_Entrada {
  Canal: string;
  TipoEvento: string;
  NombrePelicula: string;
  Pais: string;
  DiferenciaGMT: string;
}

export function builtConsultaHorariosPagoPorEventoRestEntrada(
  p_Canal: string,
  p_TipoEvento: string,
  p_NombrePelicula: string,
  p_Pais: string,
  p_DiferenciaGMT: string
) {
  var retorno: ConsultaHorariosPagoPorEventoRest_Entrada = {
    Canal: p_Canal,
    TipoEvento: p_TipoEvento,
    NombrePelicula: p_NombrePelicula,
    Pais: p_Pais,
    DiferenciaGMT: p_DiferenciaGMT,
  };

  return retorno;
}

//SALIDA

export interface ConsultaHorariosPagoPorEventoRest_Salida {
  result: string;
  result_code: string;
  Horarios: Horario[];
}

export interface Horario {
  PPV_EVENT_ID: string;
  START_DATE: string;
  END_DATE: string;
  EXPIRY_DATE: string;
  TOKEN_VALUE: string;
  DURATION: string;
  CHANNEL: string;
  DISPLAY_VALUE: string;
  PRICE: string;
  COUNTRY: string;
  CURRENCY_CODE: string;
  CUSTOMER_TYPE: string;
  SPECIAL_EVENT: string;
  PPV_CONTENT_ID: string;
  PPV_GENRE_ID: string;
  FECHAREGISTRO: string;
  IMAGEN: string;
  SINOPSIS: string;
  CHANNEL_DISPLAY: string;
  DEFINITION: string;
  CHANNEL_TITLE: string;
  IS_PACKAGE: string;
  PREVIEW_MINUTES: string;
  PSC_TOKEN: string;
  FREE_MINUTES: string;
  FREE_EVENT: string;
  LAST_ORDER_DATE: string;
  SUBJECT_MATTER_RATING: string;
  ORDER_TYPE: string;
  PROVIDER_EVENT_ID: string;
  PPV_CLASS: string;
  SKYTrackingId: string;
}

export type ConsultaHorariosPagoPorEventoRest_Respuesta =
  ConsultaHorariosPagoPorEventoRest_Salida;
